/**
 * GPGS 업적/리더보드 정의 — `data/gpgsAchievements.tsv`·`data/gpgsLeaderboards.tsv` → generated json.
 * 업적/리더보드 ID(Play Console 발급)를 코드가 아닌 데이터로 제어(no-hardcode). Console에서 발급받으면
 * `achievementId`/`leaderboardId` 컬럼의 `__ACH_*__`/`__LB_*__` placeholder를 실제 ID로 교체 후
 * `npm run export:data`로 재생성한다. `triggerEvent`는 `analytics/analyticsEvents.ts`의 snake_case 값과 일치.
 */
import achievementsJson from "./generated/gpgsAchievements.json";
import leaderboardsJson from "./generated/gpgsLeaderboards.json";

/** 업적 종류 — standard(1회 해금) / incremental(진행 누적 후 자동 해금). */
export type GpgsAchievementType = "standard" | "incremental";

/** 업적 정의 1종. conditionParam이 "-"가 아니면, 이벤트 파라미터[conditionParam] >= conditionMin일 때만 발동. */
export interface GpgsAchievementDef {
  readonly key: string;
  readonly achievementId: string;
  readonly type: GpgsAchievementType;
  /** 발동 이벤트명(analyticsEvents snake_case). */
  readonly triggerEvent: string;
  /** incremental일 때 이벤트당 증가량(standard는 0). */
  readonly step: number;
  /** 발동 조건 파라미터명("-"=조건 없음). 예: "chapter". */
  readonly conditionParam: string;
  /** conditionParam 값이 이 값 이상이어야 발동(조건 없으면 0). */
  readonly conditionMin: number;
}

/** 리더보드 정의 1종 — triggerEvent 발생 시 params[scoreParam]을 점수로 제출. */
export interface GpgsLeaderboardDef {
  readonly key: string;
  readonly leaderboardId: string;
  readonly triggerEvent: string;
  readonly scoreParam: string;
}

export const GPGS_ACHIEVEMENTS: readonly GpgsAchievementDef[] = achievementsJson.map((r) => ({
  key: r.key,
  achievementId: r.achievementId,
  type: r.type as GpgsAchievementType,
  triggerEvent: r.triggerEvent,
  step: r.step,
  conditionParam: r.conditionParam,
  conditionMin: r.conditionMin,
}));

export const GPGS_LEADERBOARDS: readonly GpgsLeaderboardDef[] = leaderboardsJson.map((r) => ({
  key: r.key,
  leaderboardId: r.leaderboardId,
  triggerEvent: r.triggerEvent,
  scoreParam: r.scoreParam,
}));

/** "조건 없음" 센티넬 — TSV 빈 셀 회피용(conditionParam). */
export const GPGS_NO_CONDITION = "-";
